import React from "react";
import CreditNotes from "./CreditNoteLists/CreditNotes";

const PendingForSalesDirectorApproval = () => {
    return <CreditNotes status="sales-director" title="pending" link="sales-director-credit-notes"/>;
};

export default PendingForSalesDirectorApproval;
